import(/* webpackMode: "eager" */ "/var/lib/neoscriber/publish/app/error.tsx");
